export const meetingFlowComponents = [
  {
    id: 'rapport',
    title: 'Rapport & Trust Building',
    conditions: (input) =>
      input.relationshipStatus === 'New' || input.meetingGoal.includes('Intro'),
    questions: [
      "How did you get started with the company?",
      "What are you most excited about this year?",
      "What keeps you up at night when it comes to your role?"
    ]
  },
  {
    id: 'framing',
    title: 'Meeting Framing',
    conditions: () => true,
    questions: [
      "Let’s make the most of our time—what’s most important to get out of this call?",
      "Would it be helpful if I shared how I typically help similar roles in your space?"
    ]
  },
  {
    id: 'strategicDiscovery',
    title: 'Discovery Questions',
    conditions: (input) => input.meetingGoal.includes('Uncover'),
    questions: [
      "What are your big goals this quarter?",
      "What’s blocking you from achieving them right now?",
      "How is success measured internally?",
      "Tell me a little more about your business?",
      "What materials do you buy, if any?",
      "How many employees do you have? Are they W2 or 1099?",
      "Who are your key employees and what do they do?",
      "Are there any upcoming projects or expansions that will impact your cash management needs?",
      "Can you share an overview of current cash flow, liquidity, and working capital?",
      "What are your primary sources of revenue, expenses, and cash inflows/outflows?",
      "Do you have outstanding debt or financing arrangements we need to consider?",
      "Anything not working that should be?",
      "What does a typical workflow look like?",
      "What tools or systems are you currently using?",
      "Where are the bottlenecks?",
      "How do you currently manage your cash balances, payments, and collections?",
      "What are your accounts receivable typically?",
      "How many days until you are typically paid?",
      "What terms do you offer your clients?",
      "What are your accounts payable?",
      "What is your average timeline to make your payments?",
      "What types of banking services or products are you currently using, and are they meeting your needs?",
      "Who extends credit to your business? Do you receive any special terms?",
      "Who handles your payroll?",
      "Who provides your merchant services? Average amount and $ per month?",
      "What is your average rate in merchant credit card sales?",
      "Do you use remote deposit?",
      "What balances do you try to keep in your business accounts?",
      "Who controls the banking relationship and other financial transactions, such as check writing, today?",
      "What are your main business expenses in descending order?",
      "Does the business use lines of credit to float working capital? What is the rate?",
      "Do you lease or own the real estate you operate out of? What are the terms and details?",
      "What other fixed assets does the business own?",
      "How has the business financed debt in the past?",
      "What is your accounting / bookkeeping system and is it integrated online?",
      "How much debt or collection write-offs do you have? What is your process to handle those?",
      "What types of financial risks (e.g., interest rate risk, foreign exchange risk, credit risk) are you exposed to?",
      "How do you manage risk around the business?",
      "Are there specific risk management strategies or hedging instruments you are interested in exploring?",
      "What uncontrollable factors (economics cycles, interest rates, etc.) affect your business?",
      "Do you have any goals to sell the business long term?",
      "Is your current bank and banker helping you achieve your goals?",
    ]
  },
  {
    id: 'valueAlignment',
    title: 'Value Alignment',
    conditions: (input) =>
      input.meetingGoal.includes('Pitch') || input.contactRole.toLowerCase().includes('finance'),
    questions: [
      "If we solved this, what kind of impact would that have?",
      "What’s most valuable to you—saving time, reducing cost, or increasing capacity?"
    ]
  },
  {
    id: 'solutionPitch',
    title: 'Solution Positioning',
    conditions: (input) => input.meetingGoal.includes('Pitch'),
    questions: [
      "Here’s how we’ve helped others solve similar problems…",
      "Let me show you what that could look like for your team."
    ]
  },
  {
    id: 'proofPoints',
    title: 'Proof & Social Validation',
    conditions: (input) =>
      input.meetingGoal.includes('Pitch') || input.contactRole.toLowerCase().includes('exec'),
    questions: [
      "Other [role]s in [industry] have seen X% improvement in Y.",
      "Would it be helpful if I shared a quick success story?"
    ]
  },
  {
    id: 'objections',
    title: 'Objection Handling',
    conditions: (input) =>
      input.industry.toLowerCase() === 'banking' || input.meetingGoal.includes('Proposal'),
    questions: [
      "What concerns do you anticipate from others internally?",
      "What are the potential roadblocks to moving forward?"
    ]
  },
  {
    id: 'processMapping',
    title: 'Buying Process Mapping',
    conditions: (input) =>
      input.meetingGoal.includes('Proposal') || input.contactRole.toLowerCase().includes('procurement'),
    questions: [
      "What does the decision-making process typically look like?",
      "Who else should be involved in the conversation?"
    ]
  },
  {
    id: 'nextSteps',
    title: 'Next Step Confirmation',
    conditions: () => true,
    questions: [
      "Would it make sense to schedule a follow-up with your team?",
      "What should we each do between now and then?"
    ]
  }
];
